module.exports = __webpack_public_path__ + "media/Reading Those Books.e39c1a4d.mp3";